import {
    ConvertCurrencyPayload,
    ICurrencyServices,
} from '@lib/domain/currency/interface';
import { ConvertCurrencyResponse } from '@lib/domain/currency';
import { HTTPService } from '@lib/infra/HTTPService/HTTPService';
import { APP_CONFIG } from '@lib/constants';

interface Dependencies {
    httpService: HTTPService;
}

export class CurrencyServices implements ICurrencyServices {
    private httpService: HTTPService;

    constructor({ httpService }: Dependencies) {
        this.httpService = httpService;
    }

    async convertCurrency(
        data: ConvertCurrencyPayload,
    ): Promise<ConvertCurrencyResponse> {
        const res = await this.httpService.getWithoutHmac({
            url: '',
            data,
            options: {
                baseURL: APP_CONFIG.GEOLOCATION_PLUGIN_URL,
            },
        });

        return res.data;
    }
    // eslint-disable-next-line
    async currencyGetList(): Promise<any> {
        const res = await this.httpService.get({
            url: 'currencies',
            data: {
                apiKey: APP_CONFIG.CURRENCY_CONVERT_API_KEY,
            },
            options: {
                baseURL: APP_CONFIG.CURRENCY_CONVERT_URL,
            },
        });

        return res.data;
    }
}
